import { useLocation } from "react-router-dom";
import { StringParam, useQueryParam } from "use-query-params";

import {
  Case,
  Default,
  Switch,
} from "../components/common/ConditionalRendering";
import useFeatureFlags from "../hooks/useFeatureFlags";
import PageNotFound from "./PageNotFound";

const FeatureEnabledRoute = ({ children }) => {
  const location = useLocation();

  const [currentOption] = useQueryParam("currentOption", StringParam);

  const [
    isDashboardListingEnabled,
    isCalendarEnabled,
    isNotificationsEnabled,
    isAvailabilityEnabled,
    isSupervisionEnabled,
    isAnalyticsEnabled,
  ] = useFeatureFlags([
    "twa_private_session_listing_dashboard",
    "twa_private_google_calender_auth",
    "twa_private_notifications",
    "twa_private_availability",
    "twa_private_supervision",
    "twa_private_analytics",
  ]);

  const isDashboardRoute = location.pathname.includes("dashboard");

  const isNotificationsRoute = location.pathname.includes("notifications");

  const isAvailabilityRoute =
    location.pathname.includes("profile") && currentOption === "availability";

  const isSupervisionRoute = location.pathname.includes("supervision");

  const isAnalyticsRoute = location.pathname.includes("analytics");

  const isDashboardRouteEnabled =
    isDashboardListingEnabled || isCalendarEnabled;

  return (
    <Switch>
      <Case condition={isDashboardRoute && !isDashboardRouteEnabled}>
        <PageNotFound link="/clients" title="Clients" />
      </Case>
      <Case condition={isNotificationsRoute && !isNotificationsEnabled}>
        <PageNotFound link="/dashboard" title="Dashboard" />
      </Case>
      <Case condition={isAvailabilityRoute && !isAvailabilityEnabled}>
        <PageNotFound link="/dashboard" title="Dashboard" />
      </Case>
      <Case condition={isSupervisionRoute && !isSupervisionEnabled}>
        <PageNotFound link="/dashboard" title="Dashboard" />
      </Case>
      <Case condition={isAnalyticsRoute && !isAnalyticsEnabled}>
        <PageNotFound link="/dashboard" title="Dashboard" />
      </Case>
      <Default>{children}</Default>
    </Switch>
  );
};

export default FeatureEnabledRoute;
